import { AppBox, AppGridBox, AppSkeletonBasicInfo, AppTitle, InfoCard } from "../../../../commons/components";
import { useAppSelector } from "../../../../hooks/app";
import { StatusEnum } from "../../../../commons/enums/status-enum";
import { IUser } from "../../../../commons/models/i-user";

interface ProfileInfoProps {
  user: IUser;
}

export default function ProfileInfo({ user: user }: ProfileInfoProps) {
  const basicInfo = [
    {
      title: user?.email ?? "",
      label: "Email",
    },
  ];

  return (
    <AppBox flexDirection="column" gap="xs">
      <AppTitle as="h5">Basic Information</AppTitle>
      <AppBox flexDirection="column" gap="sm">
        <AppGridBox columns={4} gap="sm">
          {basicInfo.map((item) => (
            <InfoCard key={item.label} alignItems="start" shadow="xs" title={item.title} label={item.label} />
          ))}
        </AppGridBox>
      </AppBox>
    </AppBox>
  );
}
